var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 138,
    viewBox: "0 0 140 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.394 20.4941L62.0767 83.6823L37.6268 56.2518C35.2453 53.6393 31.2761 53.476 28.5771 55.7619C26.0369 58.2111 25.8781 62.293 28.1008 65.0687L56.8375 97.3975C58.1076 98.867 59.854 99.5201 61.6004 99.5201C63.1881 99.5201 64.617 99.0303 65.8871 97.8873L137.967 30.1275C140.507 27.6783 140.666 23.5964 138.443 20.8207C136.062 18.2083 132.093 18.045 129.394 20.4941Z",
    fill: "#564ECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6817 137.4C103.515 137.4 133.363 106.704 133.363 68.8238C133.363 65.5583 133.205 62.456 132.728 59.3537C132.252 55.7617 129.077 53.3125 125.584 53.8023C122.091 54.2922 119.71 57.5577 120.186 61.1498C120.503 63.7622 120.662 66.3746 120.662 68.8238C120.662 99.3565 96.3709 124.338 66.6817 124.338C36.9925 124.338 12.7013 99.3565 12.7013 68.8238C12.7013 38.291 36.9925 13.3097 66.6817 13.3097C79.383 13.3097 91.7667 17.8814 101.451 26.3718C104.15 28.6577 108.12 28.3312 110.342 25.5555C112.565 22.7797 112.248 18.6978 109.548 16.412C97.6411 5.96224 82.3995 0.247559 66.6817 0.247559C29.848 0.247559 0 30.9436 0 68.8238C0 106.704 29.848 137.4 66.6817 137.4Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck3);
export default __webpack_public_path__ + "static/media/CircleCheck3.650315c276ed130b6ec4a7a641481450.svg";
export { ForwardRef as ReactComponent };